module.exports = __webpack_public_path__ + "img/light-notification.af299e32.svg";